'use client'
import React, { useState } from 'react'
import Link from 'next/link'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { ChevronDown, User, Users, MessageCircle, LogOut, Brain, Heading2, Moon, ImageIcon, Image as ImageIconLucide, BarChart3, ShieldCheck } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useUser } from '@/contexts/UserContext'
import { toast } from "sonner"
import { useTheme } from "next-themes"
import { Switch } from "@/components/ui/switch"
import { useAuth } from '@/contexts/AuthContext'
import { useRouter } from 'next/navigation'
import { useError } from '@/contexts/ErrorContext'

export default function UserAuthStatusButton() {
  const { isLoggedIn, logout } = useAuth()
  const { user } = useUser()
  const [open, setOpen] = useState(false)
  const { theme, setTheme } = useTheme()
  const router = useRouter()
  const { handleError } = useError()

  const handleLogout = async () => {
    try {
      logout()
      toast.success("ログアウトしました")
      setOpen(false)
      router.push('/login')
    } catch {
      handleError('LOGOUT_ERROR')
      setOpen(false)
    }
  }

  if (isLoggedIn && user) {
    return (
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <Button variant="outline">
            <User className="h-5 w-5" />
            <span className="ml-2">{user.username}</span>
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56" align="end">
          <DropdownMenuLabel>{user.last_name} {user.first_name} 様</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link href="/user/profile" className="flex w-full">
              <User className="mr-2 h-4 w-4" />
              <span>プロフィール</span>
            </Link>
          </DropdownMenuItem>
          {/* {!user.unlimited_usage && (
            <DropdownMenuItem asChild>
              <Link href="/user/purchase" className="flex w-full">
                <CreditCard className="mr-2 h-4 w-4" />
                <span>プラン登録・変更</span>
              </Link>
            </DropdownMenuItem>
          )} */}
          {/* {!user.unlimited_usage && (
            <DropdownMenuItem asChild>
              <Link href="/user/purchase/per-article" className="flex w-full">
                <SquarePlus className="mr-2 h-4 w-4" />
                <span>追加記事を購入</span>
              </Link>
            </DropdownMenuItem>
          )} */}
          {(user.is_staff || user.is_superuser) && (
            <>
              <DropdownMenuItem asChild>
                <Link href="/admin/report" className="flex w-full">
                  <BarChart3 className="mr-2 h-4 w-4" />
                  <span>統計レポート</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/users" className="flex w-full">
                  <Users className="mr-2 h-4 w-4" />
                  <span>ユーザー一覧</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/models" className="flex w-full">
                  <Brain className="mr-2 h-4 w-4" />
                  <span>AIモデル管理</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/heading-policies" className="flex w-full">
                  <Heading2 className="mr-2 h-4 w-4" />
                  <span>見出し設計管理</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/audience" className="flex w-full">
                  <Users className="mr-2 h-4 w-4" />
                  <span>読者レベル管理</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/tones" className="flex w-full">
                  <MessageCircle className="mr-2 h-4 w-4" />
                  <span>トーン管理</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/image-policies" className="flex w-full">
                  <ImageIcon className="mr-2 h-4 w-4" />
                  <span>画像テイスト管理</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/thumbnail-designs" className="flex w-full">
                  <ImageIconLucide className="mr-2 h-4 w-4" />
                  <span>画像オーバーレイ管理</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link href="/admin/regulation-items" className="flex w-full">
                  <ShieldCheck className="mr-2 h-4 w-4" />
                  <span>レギュレーション管理</span>
                </Link>
              </DropdownMenuItem>
            </>
          )}
          <DropdownMenuSeparator />
          <div className="flex items-center justify-between px-2 py-2">
            <div className="flex items-center">
              <Moon className="h-[1.2rem] w-[1.2rem] transition-all rotate-0 scale-100 mr-2" />
              <span className="text-sm">ダークモード</span>
            </div>
            <Switch
              checked={theme === 'dark'}
              onCheckedChange={(checked) => setTheme(checked ? 'dark' : 'light')}
            />
          </div>
          <DropdownMenuSeparator />
          <div className="p-2">
            <Button className="w-full" onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              ログアウト
            </Button>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }

  return (
    <div className="space-x-2">
      <Button asChild>
        <Link href="/login">ログイン</Link>
      </Button>
      {/* <Button asChild variant="outline">
        <Link href="/register">新規登録</Link>
      </Button> */}
    </div>
  )
}
